import React from 'react';
import Layout from '../components/layout';
import FAQBlock from '../components/FAQBlock';
import SEO from '../components/seo/seo';

export default ({ location }) => {
  return (
    <Layout>
      <SEO title="FAQ" pathname={location.pathname} />
      <div className="container pt-8">
        <div className="text-center mb-8 md:mb-16 flex flex-col">
          <h1 className="leading-tight font-sans text-shop-dark-green text-4xl w-full md:w-3/4 mb-4 flex self-center justify-center">
            FAQ
          </h1>
        </div>
        <div className="flex flex-row flex-wrap">
          <FAQBlock
            question="Which plan is right for me?"
            answer="ShopFeedback automatically sends a survey for every order you get, therefore pick the plan based on the amount of orders you receive each month."
          />
          <FAQBlock
            question="Is there a free trial?"
            answer="Yup! There is a 30 day free trial."
          />
          <FAQBlock
            question="Billing, Canceling, Etc..."
            answer="All billing takes place through Shopify itself. You can cancel by
            uninstalling the app within Shopify. You can upgrade or downgrade
            plans right inside the app."
          />
          <FAQBlock
            question="Why isn't it free?"
            answer="ShopFeedback is all in on making the best NPS app for Shopify
           and in order to do so, we charge a small monthly fee. This ensures we
           have the money to continue building out features and fixing bugs."
          />
          {/* <FAQBlock
            question="How many surveys can I send?"
            answer="With ShopFeedback you can send unlimited surveys. Since a survey
           is automatically sent for each order in your shop, that is how many
           surveys will be sent out each month."
            answerPartTwo="Your plan is based on how many responses you receive
          each month. This is different than other NPS apps, as you are only
          paying for the value you receive, and not just the amount of surveys
          that are sent out. "
          />
          <FAQBlock
            question="Why not charge for surveys?"
            answer="Let's say you are charged for sending 1000 surveys a month,
          you might only get back 30 responses, however you are paying a lot
          for only getting a 3% response rate. Some shops might have a higher
          response rate, some might have a lower one."
            answerPartTwo="When you are charged for surveys, there is no telling
           how many responses you might get per pay period. With ShopFeedback,
           it doesn't mater how many surveys get sent out, just how many responses
            you get. Our goal is to make sure you get the feedback you need to
            continue to grow your store."
          /> */}
          <FAQBlock
            question="What happens when I reach my survey limit?"
            answer="You won't be charged anything extra! One you reach your limit, the surveys will be put on pause until the next billing period begins."
          />
        </div>
      </div>
    </Layout>
  );
};
